import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../ui/Dialog/DialogActions";
import Typography from "@material-ui/core/Typography";
import TextField from "../../../../../ui/TextField";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {format, parseISO} from "date-fns";
import ru from "date-fns/locale/ru";
import {logError} from "../../../store/message";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  typography: {
    color: "#778899"
  },
  closeButton: {
    position: "absolute",
    right: 4,
    top: 4,
    color: theme.palette.grey[500]
  },
  dialog: {
    width: "476px"
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
});

const formatDate = date =>
  date ? format(parseISO(date), "dd.MM.yy", { locale: ru }) : null;

const DeclineRequestModal = ({
  requestData,
  requestCount,
  declineMany,
  open,
  handleClose,
  handleDecline,
  classes,
  isDecliningRequest,
  //declinedRequest
}) => {
  const [comment, setComment] = React.useState("");
  const [reason, setReason] = React.useState(null);

  const onConfirm = () => {
    if (comment === "" || comment === null) {
      logError("Не указана причина отказа.");
    } else {
      if (declineMany) {
        handleDecline(comment);
      } else if (requestData && requestData.id) {
        handleDecline(requestData.id, comment);
      } else {
        logError("Ошибка приложения. Не передан номер заявки.");
      }
      handleClose();
    }
  };

  const onClose = () => {
    handleClose();
  };

  const handleReasonChange = (event) => {
    let selectedReason = event.target.value;
    setReason(selectedReason);
    if (selectedReason !== "reason4") {
      setComment(selectedReason)
    }
  };

  /*React.useEffect(() => {
    if (declinedRequest && declinedRequest.success) {
      setComment("");
      handleClose();
    }
  }, [declinedRequest]);*/

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>
          {
            (requestCount && requestCount > 1)
              ? `Отклонить заявки: ${requestCount}`
              : `Отклонить заявку ${requestData ? '№'+requestData.id + 'от ' + formatDate(requestData.date) : ''}?`
          }
        </DialogTitle>
        <DialogContent>
              <Typography>Укажите причину отказа</Typography>
              <RadioGroup name="reasonDecline" value={reason} onChange={handleReasonChange}>
                <FormControlLabel value="Набор на программу приостановлен." control={<Radio />} label="Набор на программу приостановлен." />
                <FormControlLabel value="Подана заявка на другую программу на бесплатной основе." control={<Radio />} label="Подана заявка на другую программу на бесплатной основе." />
                <FormControlLabel value="Претендент на обучение по программе уже получил ранее бесплатную профессию." control={<Radio />} label="Претендент на обучение по программе уже получил ранее бесплатную профессию." />
                <FormControlLabel value="reason4" control={<Radio />} label="Другая причина" />
              </RadioGroup>
              <TextField
                value={comment}
                disabled={reason !== "reason4"}
                onChange={e => setComment(e.target.value)}
              />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isDecliningRequest}
            disabled={isDecliningRequest}
            onClick={() => onConfirm()}
            color="pink"
          >
            Отклонить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withStyles(styles)(DeclineRequestModal);
